/** Field keys shared by validateOrder and the UI, so an error lands next to its field. */
export const F = {
  orderDate: 'OrderDate',
  participantName: 'ParticipantName',
  memberNumber: 'MemberNumber',
  center: 'Center',
  product: 'Product',
} as const
